"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _DTOError = require("./DTOError");

var _default = _DTOError.DTOError;
exports["default"] = _default;